const PropDetailsLoading = () => {
  return (
    <div className="flex flex-col lg:flex-row gap-10 lg:gap-[82px] animate-pulse">
      <div className="w-full lg:flex-1 min-w-0 space-y-6">
        <div className="h-6 w-32 bg-gray-200 rounded" />
        <div className="h-8 w-3/4 bg-gray-200 rounded" />
        <div className="space-y-3">
          <div className="h-4 w-full bg-gray-200 rounded" />
          <div className="h-4 w-2/3 bg-gray-200 rounded" />
        </div>
        <div className="w-full aspect-video bg-gray-200 rounded-lg" />
        <div className="flex gap-2">
          <div className="h-6 w-20 bg-gray-200 rounded-full" />
          <div className="h-6 w-20 bg-gray-200 rounded-full" />
          <div className="h-6 w-20 bg-gray-200 rounded-full" />
        </div>
        <div className="flex gap-2">
          <div className="h-8 w-16 bg-gray-200 rounded-lg" />
          <div className="h-8 w-16 bg-gray-200 rounded-lg" />
          <div className="h-8 w-16 bg-gray-200 rounded-lg" />
        </div>
        <div className="space-y-2">
          <div className="h-4 w-32 bg-gray-200 rounded" />
          <div className="flex flex-wrap gap-2">
            <div className="h-8 w-24 bg-gray-200 rounded-full" />
            <div className="h-8 w-24 bg-gray-200 rounded-full" />
            <div className="h-8 w-24 bg-gray-200 rounded-full" />
          </div>
        </div>
        <div className="space-y-2">
          <div className="h-4 w-40 bg-gray-200 rounded" />
          <div className="h-32 w-full bg-gray-200 rounded-lg" />
        </div>
      </div>
      <div className="w-full lg:w-[350px] space-y-4">
        <div className="h-48 w-full bg-gray-200 rounded-lg" />
        <div className="h-6 w-3/4 bg-gray-200 rounded" />
        <div className="h-4 w-1/2 bg-gray-200 rounded" />
        <div className="h-10 w-full bg-gray-200 rounded-lg" />
      </div>
    </div>
  );
};

export default PropDetailsLoading;
